import { useState } from "react";
import { callApi } from "../../api";
import { useAuth } from "../useAuth";

export default () => {
  const [surveysD, setSurveysD] = useState([]);
  const { selectedBusiness } = useAuth();

  const useSurveys = async () => {
    try {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/iorequest?dest=:BID:/survey/getall`
      );
      setSurveysD(res?.data);
      if (res && res.status === true) {
        return res?.data;
      }
      return null;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log("error", e);
      return null;
    }
  };

  return {
    useSurveys,
    surveysD,
  };
};
